import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { ILayermapState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const layermapModule: Module<ILayermapState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default layermapModule
